import {Component, OnInit} from '@angular/core';

@Component({
  selector: 'services',
  templateUrl: './services.component.html',
  styleUrls: ['./services.component.sass']
})
export class ServicesComponent implements OnInit {
  selectedIndex=0;
  constructor() {
  }

  ngOnInit() {

  }

  setIndex(index:number, elem: HTMLElement){
    this.selectedIndex=index;
    setTimeout(()=> {
      // elem.scrollIntoView({ block: 'start',  behavior: 'smooth', inline: 'center' });
      const yOffset = -180;
      const y = elem.getBoundingClientRect().top + window.pageYOffset + yOffset;
      window.scrollTo({top: y, behavior: 'smooth'});
    }, 500);

  }

}
